import draggable from 'vuedraggable';
import axios from 'axios';
import _u from '../../shared/utils';
import {globalActions} from '../../store/global-actions';
import {loginControl} from '../login';
import '../inputs/file-uploader';
import {wizardStepMixin} from './wizard';
import {Cookies} from '../../shared/cookies-extended';
import {ErrorMessage, Field} from 'vee-validate';
import {confirmationEmailMixin} from '../../pages/simple-pages/index';
import utils from '../../shared/utils';
import { VideoUploadStatus, VideoStepAdditionalTextType, StoreCancellUploadingEventName } from '../../pages/wizard/video-uploading-status'
import { store } from '../../store/global-store';

const minMaxOptionsMixin = {
    computed: {
        minValue() {
            // empty to highlight this value should be overwritten
        },
        maxValue() {
            // empty to highlight this value should be overwritten
        },
        valueOptions() {
            return [];
        },
        minValueOptions() {
            return this.maxValue ?
                this.valueOptions.filter((option) => option.value == null || parseFloat(option.value) <= parseFloat(this.maxValue)) :
                this.valueOptions;
        },
        maxValueOptions() {
            return this.minValue ?
                this.valueOptions.filter((option) => option.value == null || parseFloat(option.value) >= parseFloat(this.minValue)) :
                this.valueOptions.filter((option) => option.value == null || parseFloat(option.value) > 0);
        },
    },
};

const wizardStepBasicMixin = {
    data() {
        return {
            initialPropertyType: this.modelValue.propertyType,
            isPropertyTypeChanged: false,
        };
    },
    watch: {
        'model.propertyType'(newPropertyType) {
            if (this.modelValue.id > 0 && !this.isPropertyTypeChanged &&
          this.initialPropertyType !== null && this.initialPropertyType !== newPropertyType) {
                this.isPropertyTypeChanged = true;
                const labelsList = this.$refs.labelsList;
                globalActions.openInfoModal(labelsList.getLabel('propertyChangedTitle'), labelsList.getLabel('propertyChangedMessage'));
            }
        },
    },
    activated() {
        this.isPropertyTypeChanged = false;
    },
};

const wizardPricePeriodPromptMixin = {
    computed: {
        getPricePeriodPrompt() {
            return this.model.priceModel.showPricePeriodPrompt ? this.model.priceModel.pricePeriodPrompt : null;
        },
    },
    watch: {
        'model.offerType': {
            handler(val) {
                this.model.priceModel.showPricePeriodPrompt = val === this.model.rentOfferType;
            },
            immediate: true,
        },
    },
};

const wizardStepBasicPriceMixin = {
    data() {
        return {
            isPriceTypeOpened: false,
        };
    },
    computed: {
        getPriceTypes() {
            return this._isRent ? this.model.priceModel.rentPriceTypes : this.model.priceModel.salePriceTypes;
        },
        _isRent() {
            return this.model.offerType === this.model.rentOfferType;
        },
    },
};

const wizardStepBasicPropertyMixin = {
    mixins: [wizardStepMixin, wizardStepBasicMixin, wizardPricePeriodPromptMixin, wizardStepBasicPriceMixin],
};

const wizardStepBasicInquiryMixin = {
    mixins: [wizardStepMixin, minMaxOptionsMixin, wizardStepBasicMixin],
    computed: {
        minValue() {
            return this.model.priceModel.priceMin;
        },
        maxValue() {
            return this.model.priceModel.priceMax;
        },
        valueOptions() {
            let result = null;
            if (this.model.offerType === this.model.rentOfferType) {
                result = this.model.priceModel.rentPriceOptions;
            } else {
                result = this.model.priceModel.salePriceOptions;
            }

            return result;
        },
    },
    watch: {
        'model.offerType': {
            handler() {
                this.model.priceModel.priceMin = 0;
                this.model.priceModel.priceMax = null;
            },
            immediate: false,
        },
    },
    methods: {
        isRent(rentValue) {
            return rentValue === this.model.offerType;
        },
    },
};

const wizardStepWithAddressInquiryMixin = {
    methods: {
        addressUpdated(newAddress, newRadius) {
            this.model.address = newAddress;
            this.model.locationRadius = newRadius;
        },
    },
};

const inquiryBasicStepWithPropertyTypeMixin = {
    watch: {
        'model.propertyType': {
            handler(value) {
                if (this.$refs.propertyTypeMultiselect) {
                    const options = this.$refs.propertyTypeMultiselect.options;
                    const propertyType = options.find((t) => t.value === value);
                    if (propertyType && propertyType.redirectUrl) {
                        window.location = propertyType.redirectUrl;
                    }
                }
            },
        },
    },
};

const wizardStepAfterPublishMixin = {
    methods: {
        negativeAction() {
            window.open(this.model.previewUrl, '_self');
        },

        positiveAction() {
            window.open(this.model.advertisingPlanUrl, '_self');
        },
    },
};

const multiselectLabelsMixin = {
    methods: {
        getOptionLabel(option, labels, noLabelValues = []) {
            let label = option.label;

            if (!noLabelValues.includes(option.value)) {
                const suffix = _u.getLabelByCount(option.value, labels.single, labels.lessThanFive, labels.moreThanFive);
                label = `${option.label} ${suffix}`;
            }

            return label;
        },
    },
};

const wizardBuildingInquiryMixin = {
    computed: {
        minValue() {
            return this.model.buildYear;
        },
        maxValue() {
            return this.model.lastRenovationYear;
        },
        valueOptions() {
            return this.model.yearOptions;
        },
    },
};

const contactType = Object.freeze({
    chat: 0,
    phone: 1,
});

const contactStepMixin = {
    data() {
        return {
            inputPhone: {
                entered: this.modelValue.phoneNumber,
                full: this.modelValue.phoneNumber,
            },
            phoneValid: true,
            error: null,
            showForceCheckbox: false,
            showContactTime: false,
            quickContactTimes: [],
        };
    },
    watch: {
        'inputPhone.full'(value) {
            this.model.phoneNumber = value;
            this.model['isDirty'] = true;

            if (value.length) {
                this.showForceCheckbox = true;
                this.model.forceShowPhoneNumber = true;
                this.model.preferableContactType = contactType.phone;
            } else {
                this.model.forceShowPhoneNumber = false;
                this.model.preferableContactType = contactType.chat;
            }
        },

        'model.preferableContactType':
        {
            handler(value) {
                if (value === contactType.chat) {
                    this.showForceCheckbox = true;
                    this.model.forceShowPhoneNumber = false;
                } else {
                    this.showForceCheckbox = true;
                    this.model.forceShowPhoneNumber = true;
                }
            },

            immediate: true,
        },
        'model.forceShowPhoneNumber': {
            handler(value) {
                this.showContactTime = value;
            },
            immediate: true,
        },
    },
    methods: {
        checkPhoneValidation(isValid, error) {
            this.phoneValid = isValid;
            this.error = error;
        },
        setQuickContactTime(time) {
            this.model.startAtTime = time.start;
            this.model.endAtTime = time.end;
        },
        _getQuickLinkTime(hours, minutes) {
            const dateTime = new Date();
            dateTime.setHours(hours);
            dateTime.setMinutes(minutes);

            return dateTime.toISOString();
        },
        _initQuickLinks() {
            this.quickContactTimes = [{
                start: this._getQuickLinkTime(10, 0),
                end: this._getQuickLinkTime(22, 0),
            }, {
                start: this._getQuickLinkTime(19, 0),
                end: this._getQuickLinkTime(23, 0),
            }, {
                start: this._getQuickLinkTime(9, 0),
                end: this._getQuickLinkTime(17, 0),
            }];
        },
    },
    created() {
        this._initQuickLinks();
        if (this.model.startAtTime == null || this.model.endAtTime == null) {
            this.setQuickContactTime(this.quickContactTimes[0]);
        }
    },
};

const featuresStepMixin = {
    data() {
        const columnsCount = 3;
        return {
            rowsCount: Math.ceil(Object.keys(this.modelValue.featuresOptions).length / columnsCount),
        };
    },
};

const commercialFeaturesStepMixin = {
    data() {
        const columnsCount = 3;
        return {
            rowsCount: Math.ceil(this.modelValue.featuresCount / columnsCount),
        };
    },
};

const wizardStepLogin = {
    template: '#wizard-step-login',
    mixins: [wizardStepMixin, loginControl],
    props: {
        redirectUrl: {},
    },
    data() {
        return {
            loginMode: false,
            returnUrl: this.redirectUrl,
            submitAction: this.submitForm,
        };
    },
    computed: {
        authForm() {
            return this.$refs.form;
        },
    },
    methods: {
        _updateReturnUrl() {
            // overrides loginControl._updateReturnUrl()
            // this method need to return user back to current page after login
            // we should not return user back after wizard login
        },

        startFormSubmit() {
            this._progressStarted();
        },

        _handleSubmitError() {
            this._progressStopped();
        },

        afterRequestSendingActions() {
            this.stepInProgress = false;
        },

        handleSuccessResult(response) {
            if (response && response.status === 200) {
                if (this.loginMode) {
                    globalActions.loginAdvertWizard();
                } else {
                    if (response.data?.redirectUrl && this.invitationId) {
                        window.location.href = response.data.redirectUrl;
                    } else {
                        globalActions.registerAdvertWizard();
                    }
                }
            }
        },
    },
};

const wizardStepConfirmEmail = {
    template: '#wizard-step-confirm-email',
    mixins: [wizardStepMixin, confirmationEmailMixin],
    props: {
        redirectUrl: {},
    },
    data() {
        return {
            initialEmail: '',
        };
    },
    computed: {
        actualEmail: {
            get() {
                return this.model.email;
            },
            set(value) {
                if (value) {
                    this.model.email = value;
                }
            },
        },
    },
    methods: {
        onValidCodeAction() {
            globalActions.loginAdvertWizard();
        },
    },
    mounted() {
        this.initialEmail = this.model.email;
    },
};

const wizardStepBasicSelect = {
    template: '#wizard-step-basic-select',
    mixins: [wizardStepMixin, wizardStepAfterPublishMixin],
    data() {
        return {
            textInfo: '',
        };
    },
    methods: {
        negativeAction() {
            window.open(this.model.url, '_self');
        },

        positiveAction() {
            this._getWizard().goNext();
        },

        _getWizard() {
            return this.$parent.$parent.$parent.$parent;
        },

        buildInfoLabel(selectedPropertyType, selectedAddress, enteredPriceMin, enteredPriceMax) {
            const propertyType = this.model.propertyTypesNoun.find((p) => p.value === selectedPropertyType);
            const address = selectedAddress ? selectedAddress : this.model.address.formatted;
            const priceInfoMin = enteredPriceMin;
            const priceInfoMax = enteredPriceMax;

            const priceInfo = (priceInfoMin === 0 || priceInfoMin) && priceInfoMax ?
                `${this.model.additionalLabels.fromLabel} ${priceInfoMin} ${this.model.additionalLabels.toLabel} ${priceInfoMax} ${this.model.additionalLabels.currencyCodeLabel}` :
                null;

            return priceInfo ?
                `${propertyType.label} ${this.model.additionalLabels.aroundLabel} "${address}" ${priceInfo}` :
                `${propertyType.label} ${this.model.additionalLabels.aroundLabel} "${address}"`;
        },
    },
    watch: {
        modelValue: {
            handler(newValue) {
                this.model = newValue;
                this.textInfo = this.buildInfoLabel(
                    newValue.propertyType,
                    newValue.address.formatted,
                    newValue.priceModel.priceMin,
                    newValue.priceModel.priceMax);
            },
            immediate: true,
        },
    },
};

const wizardStepPrepareForInquiry = {
    components: {
        Field: Field,
    },
    template: '#wizard-step-prepare-for-inquiry',
    mixins: [wizardStepMixin, minMaxOptionsMixin, wizardStepBasicMixin],
    data() {
        return {
            showInfo: true,
            showSearch: false,
            showNotPublishModal: false,
            submitAction: this.goNext,
            cancelAction: this.goSearch,
        };
    },
    computed: {
        disableBodyScroll() {
            return this.showInfo && this.isMobile;
        },

        isMobile() {
            const mobileDeviceTriggerWidth = 576;
            return window.innerWidth < mobileDeviceTriggerWidth;
        },
    },
    methods: {
        closeInfo() {
            this.showInfo = false;
        },
        goSearch() {
            this.openNotPublishModal();
        },
        goNext() {
            this._setCookies();
            // TODO: should be refactored when vuex will be added to wizard
            this.$emit('load-next-step');
            this.$emit('remove-step', this.model.stepId);
            window.history.back();
        },
        openNotPublishModal() {
            if (this.showInfo) {
                this.showNotPublishModal = true;
            }
        },
        closeNotPublishModal() {
            this.showNotPublishModal = false;
            this.showSearch = true;
            this.showInfo = false;
            this._setCookies();
            this.$emit('hide-actions');
        },
        _setCookies() {
            const extraLongExpiration = 365 * 1000;
            Cookies.setWithBackupAsync(this.model.stepCookie, 'true', {expires: extraLongExpiration});
        },
    },
};

const wizardStepUploadVideo = {
    template: '#wizard-step-video',
    mixins: [wizardStepMixin],
    components: { draggable },
    data() {
        wizardStepMixin
        return {
            isDeleteVideoModalOpened: false,
            allVideos: [],
            VideoStepAdditionalTextType,
            additionalInfoTextType: VideoStepAdditionalTextType.WAITING_FOR_APPROVAL,
            showErrorMessage: false,
        };
    },
    mounted() {
        if (this.model.video) {
            this.allVideos.push(this.model.video);
        }
    },
    computed: {
        hasVideo() {
            return this.allVideos && this.allVideos.length > 0;
        },
    },
    watch: {
        modelValue: {
            handler(newValue) {
                if (newValue.stepName === 'video') {
                    this.initComponent();
                }
            },
        },
    },
    methods: {
        changeVideoUploadingStatus(status) {
            this.$emit('change-video-uploading-status', status);
        },
        videoUploadCanceled() {
            this.additionalInfoTextType = VideoStepAdditionalTextType.WAITING_FOR_APPROVAL;
            this.changeVideoUploadingStatus(VideoUploadStatus.CLOSED);
        },
        videoUploadStarted(fileName) {
            this.additionalInfoTextType = VideoStepAdditionalTextType.IN_PROGRESS;
            this.$emit('start-video-uploading', fileName);
        },
        videoUploadFailed() {
            this.additionalInfoTextType = VideoStepAdditionalTextType.WAITING_FOR_APPROVAL;
            this.changeVideoUploadingStatus(VideoUploadStatus.FAILED);
        },
        videoUploaded(response) {
            this.allVideos.push(response.video);
            this.additionalInfoTextType = VideoStepAdditionalTextType.WAITING_FOR_APPROVAL;
            this.changeVideoUploadingStatus(VideoUploadStatus.SUCCESS);
        },
        uploadStarted() {
            this._progressStarted();
        },
        addVideo(video) {
            this.allVideos.push(video);
        },
        async deleteVideo() {
            try {
                const url = `${this.model.videoDeleteUrl}/${this.allVideos[0].id}`;
                await axios.post(url);

                this.allVideos.splice(0, 1);
                this.showErrorMessage = false;
            }
            catch {
                this.showErrorMessage = true;
            }
        },
        tryDeleteVideoWithConfirmation() {
            this.isDeleteVideoModalOpened = true;
        },
        async deleteVideoConfirmed() {
            await this.deleteVideo();
        },
        deleteVideoCancelled() { },
        tryCancelUploadingWithConfirmation() {
            this.$emit('try-cancel');
        },
    },
};

const wizardStepUploadPhotos = {
    template: '#wizard-step-upload-photos',
    mixins: [wizardStepMixin],
    components: {draggable},
    data() {
        return {
            isDeleteModalOpened: false,
            photoToDelete: null,
            allPhotos: [],
        };
    },
    computed: {
        hasPhotos() {
            return this._hasMedia && this.photos && this.photos.length;
        },

        photosCount() {
            return this.allPhotos ? this.allPhotos.length : 0;
        },

        hasTempPhotos() {
            return this._hasMedia && this.tempPhotos && this.tempPhotos.length;
        },

        tempPhotos() {
            return this.model.media.tempPhotos;
        },

        photos() {
            return this.model.media.photos;
        },

        photosLimit() {
            const limit = this.model ? this.model.photosLimitConst : 0;
            const uploaded = this.allPhotos ? this.allPhotos.length : 0;
            return limit - uploaded > 0 ? limit - uploaded : 0;
        },

        _hasMedia() {
            return this.model && this.model.media;
        },
    },
    watch: {
        tempPhotos: {
            handler() {
                for (const photo of this.tempPhotos) {
                    photo.isTemp = true;
                }
            },
            deep: true,
            immediate: true,
        },

        allPhotos: {
            handler(value) {
                this._refreshIndexes(value);
            },

            deep: true,
        },
    },
    methods: {
        photosUploaded(photos) {
            const notNullPhotos = photos.filter((p) => p !== null);
            this.tempPhotos.push(...notNullPhotos);
            this.allPhotos.push(...notNullPhotos);
        },

        uploadStarted() {
            this._progressStarted();
        },

        uploadCompleted() {
            this._progressStopped();
        },

        deletePhoto(photo) {
            if (photo.isTemp) {
                this.tempPhotos.splice(this.tempPhotos.indexOf(photo), 1);
            } else {
                this.photos.splice(this.photos.indexOf(photo), 1);
            }

            this.allPhotos.splice(this.allPhotos.indexOf(photo), 1);
        },

        deletePhotoConfirmed() {
            this.deletePhoto(this.photoToDelete);
            this.photoToDelete = null;
        },

        deletePhotoCancelled() {
            this.photoToDelete = null;
        },

        tryDeletePhotoWithConfirmation(photo) {
            if (photo.isTemp) {
                this.deletePhoto(photo);
            } else {
                this.showDeletePhotoConfirmation(photo);
            }
        },

        showDeletePhotoConfirmation(photo) {
            this.photoToDelete = photo;
            this.isDeleteModalOpened = true;
        },

        isPhotoVisible(photo) {
            return true;
        },

        setCoverPhoto(photo) {
            this.allPhotos.splice(this.allPhotos.indexOf(photo), 1);
            this.allPhotos.unshift(photo);
        },

        _refreshIndexes(photos) {
            for (let i = 0; i < photos.length; i++) {
                photos[i].index = i;
            }
        },
    },
    mounted() {
        let allPhotos = [];

        if (this.hasPhotos) {
            allPhotos = allPhotos.concat(this.photos).sort((p) => p.index); // sort collection copy to avoid triggering  stepModel watch
        }

        if (this.hasTempPhotos) {
            allPhotos = allPhotos.concat(this.tempPhotos.sort((p) => p.index).reverse());

            this.$nextTick(() => {
                this.model['isDirty'] = true;
            });
        }

        this.allPhotos = allPhotos;
    },
};

const wizardStepPublishInfoInquiry = {
    template: '#wizard-step-publish-info-inquiry',
    mixins: [wizardStepMixin],
    props: {
        redirectUrl: {},
    },
    data() {
        return {
            cancelAction: this._getCancelAction(this.modelValue.visible),
        };
    },
    watch: {
        'value.visible': {
            handler(value) {
                this.cancelAction = this._getCancelAction(value);
                this.stepLoaded();
            },
        },
    },
    methods: {
        redirectToPreview() {
            window.location.href = `${this.redirectUrl}/${this.model.id}`;
        },

        _getCancelAction(isVisible) {
            return isVisible ? this.redirectToPreview : null;
        },

        async _setCookies() {
            const extraLongExpiration = 365 * 1000;
            Cookies.setWithBackupAsync(this.model.stepCookie, 'true', {expires: extraLongExpiration});
        },
    },
    async mounted() {
        await this._setCookies();
    },
};

function initWizardAdvertStepsComponents(app) {
    const initSimpleStep = (name, mixins = []) => app.component(name, {
        template: `#${name}`,
        components: {
            Field: Field,
            ErrorMessage: ErrorMessage,
        },
        mixins: [wizardStepMixin, ...mixins],
    });

    app.component('wizard-step-login', wizardStepLogin);
    app.component('wizard-step-confirm-email', wizardStepConfirmEmail);

    app.component('wizard-step-basic', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic',
        mixins: [wizardStepBasicPropertyMixin],
    });

    app.component('wizard-step-basic-1', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-1',
        mixins: [wizardStepBasicPropertyMixin],
    });

    app.component('wizard-step-basic-2', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-2',
        mixins: [wizardStepMixin],
    });

    app.component('wizard-step-basic-address', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-address',
        mixins: [wizardStepMixin, wizardStepBasicMixin],
    });

    app.component('wizard-step-basic-price', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-price',
        mixins: [wizardStepMixin, wizardPricePeriodPromptMixin, wizardStepBasicPriceMixin],
    });

    app.component('wizard-step-basic-inquiry', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-inquiry',
        mixins: [wizardStepBasicInquiryMixin, inquiryBasicStepWithPropertyTypeMixin, wizardStepWithAddressInquiryMixin],
    });

    app.component('wizard-step-basic-1-inquiry', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-1-inquiry',
        mixins: [
            wizardStepBasicInquiryMixin,
            inquiryBasicStepWithPropertyTypeMixin,
            wizardStepWithAddressInquiryMixin,
            wizardPricePeriodPromptMixin],
    });

    app.component('wizard-step-basic-solidarity-inquiry', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-solidarity-inquiry',
        mixins: [wizardStepBasicInquiryMixin, wizardStepWithAddressInquiryMixin],
    });

    app.component('wizard-step-basic-2-inquiry', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-basic-2-inquiry',
        mixins: [wizardStepMixin, wizardStepWithAddressInquiryMixin],
    });

    app.component('wizard-step-basic-select', wizardStepBasicSelect);

    app.component('wizard-step-advertising-plan', {
        template: '#wizard-step-advertising-plan',
        mixins: [wizardStepMixin, wizardStepAfterPublishMixin],
        methods: {
            isProperty() {
                return this.model.isProperty;
            },
        },
    });

    app.component('wizard-step-deal-analysis-plan', {
        template: '#wizard-step-deal-analysis-plan',
        mixins: [wizardStepMixin, wizardStepAfterPublishMixin],
        methods: {
            async negativeAction() {
                const data = {
                    id: this.model.id,
                    promotionType: this.model.newPromotionType,
                };
                await axios.post(this.model.changePromotionTypeUrl, data);

                window.open(this.model.previewUrl, '_self');
            },
            getPositiveButtonId() {
                const guid = utils.genUid();
                return `${this.model.positiveActionButtonPrefix}${guid}`;
            },
        },
    });

    app.component('wizard-step-prepare-for-inquiry', wizardStepPrepareForInquiry);

    initSimpleStep('wizard-step-bedrooms', [multiselectLabelsMixin]);
    initSimpleStep('wizard-step-bedrooms-inquiry', [multiselectLabelsMixin]);
    initSimpleStep('wizard-step-floor-area');

    app.component('wizard-step-floor-area-inquiry', {
        template: '#wizard-step-floor-area-inquiry',
        mixins: [wizardStepMixin, minMaxOptionsMixin],
        data() {
            return {
                isMinSelectOpen: false,
                isMaxSelectOpen: false,
            };
        },
        computed: {
            minValue() {
                return this.model.floorAreaMin;
            },
            maxValue() {
                return this.model.floorAreaMax;
            },
            valueOptions() {
                return this.model.floorAreaOptions;
            },
        },
    });

    app.component('wizard-step-land-area', {
        template: '#wizard-step-land-area',
        mixins: [wizardStepMixin],
        data() {
            return {
                isAreaMetricSelectActive: false,
            };
        },
    });

    app.component('wizard-step-land-area-inquiry', {
        template: '#wizard-step-land-area-inquiry',
        mixins: [wizardStepMixin, minMaxOptionsMixin],
        data() {
            return {
                isMinSelectOpen: false,
                isMaxSelectOpen: false,
            };
        },
        computed: {
            minValue() {
                return this.model.landAreaMin;
            },
            maxValue() {
                return this.model.landAreaMax;
            },
            valueOptions() {
                return this.model.landAreaOptions;
            },
        },
    });

    initSimpleStep('wizard-step-bathrooms', [multiselectLabelsMixin]);
    initSimpleStep('wizard-step-bathrooms-inquiry', [multiselectLabelsMixin]);
    initSimpleStep('wizard-step-building');

    app.component('wizard-step-building-inquiry', {
        template: '#wizard-step-building-inquiry',
        mixins: [wizardStepMixin, minMaxOptionsMixin, wizardBuildingInquiryMixin],
    });

    app.component('wizard-step-building-inquiry-commercial', {
        template: '#wizard-step-building-inquiry-commercial',
        mixins: [wizardStepMixin, minMaxOptionsMixin, wizardBuildingInquiryMixin],
    });

    app.component('wizard-step-upload-photos', wizardStepUploadPhotos);
    app.component('wizard-step-video', wizardStepUploadVideo);

    initSimpleStep('wizard-step-house-floors');
    initSimpleStep('wizard-step-building-floors');

    initSimpleStep('wizard-step-description');
    initSimpleStep('wizard-step-rent-bond');

    import('moment').then(({default: moment}) => {
        app.component('wizard-step-availability',
            {
                template: '#wizard-step-availability',
                mixins: [wizardStepMixin],
                data() {
                    return {
                        isDatepickerOpen: false,
                    };
                },
                computed: {
                    formattedDate: {
                        get() {
                            return moment(this.model.availableFrom).format('YYYY-MM-DD');
                        },
                        set(date) {
                            this.model.isAvailableNow = false;
                            this.model.availableFrom = date;
                        },
                    },
                },
            });
    });

    app.component('wizard-step-contact-info', {
        components: {
            Field: Field,
        },
        template: '#wizard-step-contact-info',
        mixins: [wizardStepMixin, contactStepMixin],
    });

    import('moment').then(({default: moment}) => {
        app.component('wizard-step-open-house',
            {
                template: '#wizard-step-open-house',
                mixins: [wizardStepMixin],
                data() {
                    return {
                        editedShowcase: {},
                    };
                },
                computed: {
                    editedShowcaseStartTime: {
                        get() {
                            return this.editedShowcase.startAtTime;
                        },
                        set(newValue) {
                            this.editedShowcase.startAtTime = newValue;
                        },
                    },
                    editedShowcaseEndTime: {
                        get() {
                            return this.editedShowcase.endAtTime;
                        },
                        set(newValue) {
                            this.editedShowcase.endAtTime = newValue;
                        },
                    },
                    hasOpenHouseDates() {
                        return this.model && this.model.openHouseShowcaseDates && this.model.openHouseShowcaseDates.length;
                    },
                },
                watch: {
                    'editedShowcase.date'(newDate) {
                        if (this.editedShowcase) {
                            this.editedShowcase.startAtTime = this.setShowCaseDate(this.editedShowcase.startAtTime, newDate);
                            this.editedShowcase.endAtTime = this.setShowCaseDate(this.editedShowcase.endAtTime, newDate);
                        }
                    },
                },
                methods: {
                    addShowcase() {
                        const start = this._initShowcaseDate(1);
                        const end = this._initShowcaseDate(2);

                        this.editedShowcase = {
                            date: new Date(),
                            startAtTime: start,
                            endAtTime: end,
                        };

                        this.model.openHouseShowcaseDates.push(this.editedShowcase);
                    },
                    editShowcase(showcase) {
                        this.editedShowcase = showcase;
                    },
                    deleteShowcase(index) {
                        this.model.openHouseShowcaseDates.splice(index, 1);
                    },
                    saveShowcase() {
                        this.editedShowcase = null;
                    },
                    isShowcaseEdited(showcase) {
                        return showcase === this.editedShowcase;
                    },
                    setShowCaseDate(dateString, newDateString) {
                        const date = new Date(dateString);
                        const newDate = new Date(newDateString);

                        date.setDate(newDate.getDate());
                        date.setMonth(newDate.getMonth());
                        date.setYear(newDate.getFullYear());

                        return moment(date).toISOString();
                    },
                    _initShowcaseDate(additionalHours) {
                        const date = new Date();

                        date.setHours(date.getHours() + additionalHours);
                        date.setMinutes(0);
                        date.setSeconds(0);

                        return date.toISOString();
                    },
                },
            });
    });

    initSimpleStep('wizard-step-indoor-features', [featuresStepMixin]);
    initSimpleStep('wizard-step-indoor-features-inquiry', [featuresStepMixin]);
    initSimpleStep('wizard-step-outdoor-features', [featuresStepMixin]);
    initSimpleStep('wizard-step-outdoor-features-inquiry', [featuresStepMixin]);
    initSimpleStep('wizard-step-environmental-friendliness', [featuresStepMixin]);
    initSimpleStep('wizard-step-environmental-friendliness-inquiry', [featuresStepMixin]);
    initSimpleStep('wizard-step-safety');
    initSimpleStep('wizard-step-building-commercial');
    initSimpleStep('wizard-step-condition');
    initSimpleStep('wizard-step-parking');
    initSimpleStep('wizard-step-parking-inquiry');
    initSimpleStep('wizard-step-business-purpose');
    initSimpleStep('wizard-step-business-purpose-inquiry');
    initSimpleStep('wizard-step-payment-terms');
    initSimpleStep('wizard-step-retail-purpose');
    initSimpleStep('wizard-step-retail-purpose-inquiry');
    initSimpleStep('wizard-step-indoor-utilities');
    initSimpleStep('wizard-step-land-status');
    initSimpleStep('wizard-step-land-utilities', [commercialFeaturesStepMixin]);
    initSimpleStep('wizard-step-space-info');
    initSimpleStep('wizard-step-around', [featuresStepMixin]);
    initSimpleStep('wizard-step-around-inquiry', [featuresStepMixin]);

    app.component('wizard-step-publish-info-inquiry', wizardStepPublishInfoInquiry);

    app.component('wizard-step-solidarity', {
        template: '#wizard-step-solidarity',
        mixins: [wizardStepMixin],
    });

    app.component('wizard-step-promotion-hint', {
        template: '#wizard-step-promotion-hint',
        props: {
            infoText: {
                type: String,
                required: true,
            },
            infoIcon: {
                type: String,
                required: true,
            },
            actionText: {
                type: String,
                requeired: true,
            },
            actionIcon: {
                type: String,
                required: true,
            },
            onPositiveAction: {
                type: Function,
                default: () => {},
                required: true,
            },
            positiveActionButtonName: {
                type: String,
                required: true,
            },
            onNegativeAction: {
                type: Function,
                default: () => {},
                required: true,
            },
            negativeActionButtonName: {
                type: String,
                required: true,
            },
            positiveActionButtonId: {
                type: String,
                required: false,
            },
            negativeActionButtonId: {
                type: String,
                required: false,
            },
        },
    });
}

export default initWizardAdvertStepsComponents;
